export default "__VITE_ASSET__fd7d033b__"